export default (window) => {
    if (window.location.pathname) { // because of the testing environment
        const optionalHash = window.location.hash || "";
        window.location = "/TradeIdeasMonitor/monitor?returnUri=" + encodeURIComponent(window.location.pathname + optionalHash);
    }
}